// icons/nav/checkup.svg

export const CheckupIcon = (props) => (
  <svg
    className={props.className}
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.67725 2.32422L13.5764 7.22339L7.34898 13.4508L2.4498 13.4508L2.4498 8.55166L8.67725 2.32422ZM8.67725 5.15265L4.4498 9.38009V11.4508H6.52055L10.748 7.22339L8.67725 5.15265Z"
      fill="#EE7F18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.87917 2.12132C10.0507 0.949748 11.9502 0.949746 13.1218 2.12132L13.7783 2.77785C14.9499 3.94943 14.9499 5.84892 13.7783 7.0205L12.8692 7.92959L11.455 6.51538L12.3641 5.60628C12.7547 5.21576 12.7547 4.58259 12.3641 4.19207L11.7076 3.53553C11.3171 3.14501 10.6839 3.14501 10.2934 3.53553L9.38429 4.44463L7.97007 3.03041L8.87917 2.12132Z"
      fill="#EE7F18"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.4854 17.1914H2.48535V15.1914H16.4854V17.1914Z"
      fill="#EE7F18"
    />
  </svg>
);
